import { status } from 'skin/event/status';

const del = (obj, ms, story, data, d, action) => {
	const key = story.s.msProT.table.propT.row
	data.delRow(ms, 'propT', key)
	return status.ignore
}
export default del;